import React, {Component} from 'react';
import {Button, Modal, Row, Col} from 'react-bootstrap';
import PropTypes from 'prop-types';

import SpogButton from 'components/ui/form/SpogButton';

import 'style/components/ui/layout/panel/spog-modal.scss';

/** Component to render a modal panel */
class SpogModal extends Component {

    static propTypes = {
        title:           PropTypes.string, // The text for the title
        closeText:       PropTypes.string, // The text for close button
        acceptText:      PropTypes.string, // The text for accept button
        showAccept:      PropTypes.bool, // True when the accept button should be shown
        hideClose:       PropTypes.bool, // True when the close button should not be shown
        showModal:       PropTypes.bool, // True when the modal is visible
        onClose:         PropTypes.func, // Function to close the modal
        onAccept:        PropTypes.func, // Listener when the modal was accepted
        buttonDisable:   PropTypes.bool, // True if the user doesnt write something
        hideFooter:      PropTypes.bool, // True to hide the default footer
        dialogClassName: PropTypes.string // Modal class to custom width
    };

    static defaultProps = {
        title:      'Title',
        closeText:  'Close',
        acceptText: 'Ok',
        showAccept: false,
        hideClose:  false,
        showModal:  false
    };

    /**
     * Set the handles methods
     */
    componentWillMount() {
        this.handleClick = this.handleClick.bind(this);
    }


    /**
     * When the user push the "remove button" inside the modal, it will trigger two
     * actions, onAccept and onClose
     */
    handleClick() {
        const {onClose, onAccept} = this.props;

        onAccept && onAccept();
        onClose && onClose();
    }

    renderHeader() {
        const { title, onClose } = this.props;

        return (
            <Modal.Header closeButton>
                <Modal.Title>
                    {title}
                    <div className="pull-right"> <SpogButton noBorders onClick={onClose} icon="times"/> </div>
                </Modal.Title>
            </Modal.Header>
        );
    }

    renderBody() {
        const { children } = this.props;

        return (
            <Modal.Body>
                <Row>
                    <Col md={12} className="modal-row modal-message">
                        {children}
                    </Col>
                </Row>
            </Modal.Body>
        );
    }

    renderFooter() {
        const {hideFooter} = this.props;

        if (!hideFooter) {
            return (
                <Modal.Footer>
                    {this.renderCloseButton()}
                    <span className="pull-right"> {this.renderAcceptButton()}</span>
                </Modal.Footer>
            );
        }

        return null;
    }

    renderCloseButton() {
        const {
            onClose,
            closeText,
            hideClose,
            acceptConfirm
        } = this.props;

        const style = acceptConfirm ? 'danger' : 'info';


        return hideClose ? null :
            <Button bsStyle={style} onClick={onClose}>{closeText}</Button>
        ;
    }

    renderAcceptButton() {
        const { acceptText, showAccept, buttonDisable, acceptConfirm } = this.props;

        const style = acceptConfirm ? 'info' : 'danger';

        return showAccept ? (
            <Button
                bsStyle={style}
                bsSize="small"
                disabled={buttonDisable}
                onClick={this.handleClick}
            >
                {acceptText}
            </Button>
        ) : null;
    }

    render() {
        const { showModal, dialogClassName } = this.props;

        return (
            <Modal show={showModal} className={'spog-modal'} dialogClassName={dialogClassName}>
                {this.renderHeader()}
                {this.renderBody()}
                {this.renderFooter()}
            </Modal>
        );
    }
}

export default SpogModal;



// WEBPACK FOOTER //
// ./src/components/ui/layout/panel/SpogModal.jsx